const set = (key: string, value: any) => window.localStorage.setItem(key, value);

const get = (key: string) => window.localStorage.getItem(key);

export default {
  set,
  get
};
